import {
  MERCHANT_INVOICE_EMAIL_REQUEST,
  MERCHANT_INVOICE_EMAIL_SUCCESS,
  MERCHANT_INVOICE_EMAIL_FAIL,
  ADMIN_GIFTCARDSEND_FAIL,
  ADMIN_GIFTCARDSEND_REQUEST,
  ADMIN_GIFTCARDSEND_SUCCESS,
  CUSTOMER_ABADONEDMAIL_FAIL,
  CUSTOMER_ABADONEDMAIL_REQUEST,
  CUSTOMER_ABADONEDMAIL_SUCCESS,
  ORDERDELAYMAIL_SEND_FAIL,
  ORDERDELAYMAIL_SEND_REQUEST,
  ORDERDELAYMAIL_SEND_SUCCESS,
  CUSTOMERS_REVIEWMAIL_FAIL,
  CUSTOMERS_REVIEWMAIL_REQUEST,
  CUSTOMERS_REVIEWMAIL_SUCCESS,
  ORDERPROCESSINGTIME_MAIL_SEND_FAIL,
  ORDERPROCESSINGTIME_MAIL_SEND_REQUEST,
  ORDERPROCESSINGTIME_MAIL_SEND_SUCCESS,
  EMAIL_SYS_LIST_REQUEST,
  EMAIL_SYS_LIST_SUCCESS,
  EMAIL_SYS_LIST_FAIL,
} from "./emailTypes";

export const emailSendReducer = (state = { emails: [] }, action) => {
  switch (action.type) {
    case MERCHANT_INVOICE_EMAIL_REQUEST:
      return { ...state, loading: true };

    case MERCHANT_INVOICE_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };

    case MERCHANT_INVOICE_EMAIL_FAIL:
      return { ...state, loading: false, error: action.payload };

    case ADMIN_GIFTCARDSEND_REQUEST:
      return { ...state, loading: true };

    case ADMIN_GIFTCARDSEND_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case ADMIN_GIFTCARDSEND_FAIL:
      return { ...state, loading: false, error: action.payload };

    case CUSTOMER_ABADONEDMAIL_REQUEST:
      return { ...state, loading: true };

    case CUSTOMER_ABADONEDMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case CUSTOMER_ABADONEDMAIL_FAIL:
      return { ...state, loading: false, error: action.payload };

    case ORDERDELAYMAIL_SEND_REQUEST:
    case ORDERPROCESSINGTIME_MAIL_SEND_REQUEST:
      return { ...state, loading: true };

    case ORDERDELAYMAIL_SEND_SUCCESS:
    case ORDERPROCESSINGTIME_MAIL_SEND_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case ORDERDELAYMAIL_SEND_FAIL:
    case ORDERPROCESSINGTIME_MAIL_SEND_FAIL:
      return { ...state, loading: false, error: action.payload };

    case CUSTOMERS_REVIEWMAIL_REQUEST:
      return { ...state, loading: true };

    case CUSTOMERS_REVIEWMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case CUSTOMERS_REVIEWMAIL_FAIL:
      return { ...state, loading: false, error: action.payload };

    // EMAIL SYSTEM REDUCER PART

    case EMAIL_SYS_LIST_REQUEST:
      return { ...state, loading: true };

    case EMAIL_SYS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        emails: action.payload.emails,
        total: action.payload.total,
      };

    case EMAIL_SYS_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
